var _rect, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgCohort = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "#E6F3FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.3203 14.9609L23.7422 8.85547C23.7129 8.53906 23.4609 8.28906 23.1445 8.25781L17.0391 7.67969H17.0312C16.9687 7.67969 16.9199 7.69922 16.8828 7.73633L7.73632 16.8828C7.71821 16.9009 7.70385 16.9223 7.69405 16.946C7.68424 16.9696 7.6792 16.9949 7.6792 17.0205C7.6792 17.0461 7.68424 17.0714 7.69405 17.095C7.70385 17.1187 7.71821 17.1401 7.73632 17.1582L14.8418 24.2637C14.8789 24.3008 14.9277 24.3203 14.9805 24.3203C15.0332 24.3203 15.082 24.3008 15.1191 24.2637L24.2656 15.1172C24.3047 15.0762 24.3242 15.0195 24.3203 14.9609ZM14.9785 22.3027L9.69725 17.0215L17.5039 9.21484L22.3281 9.67188L22.7851 14.4961L14.9785 22.3027ZM19.2812 11C18.334 11 17.5625 11.7715 17.5625 12.7188C17.5625 13.666 18.334 14.4375 19.2812 14.4375C20.2285 14.4375 21 13.666 21 12.7188C21 11.7715 20.2285 11 19.2812 11ZM19.2812 13.3438C18.9355 13.3438 18.6562 13.0645 18.6562 12.7188C18.6562 12.373 18.9355 12.0938 19.2812 12.0938C19.6269 12.0938 19.9062 12.373 19.9062 12.7188C19.9062 13.0645 19.6269 13.3438 19.2812 13.3438Z",
    fill: "#1890FF"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCohort, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Cohort.83f42a73.svg";
export { ForwardRef as ReactComponent };